import { render } from "./MultipleSelection.vue?vue&type=template&id=75935e26"
import script from "./MultipleSelection.vue?vue&type=script&lang=ts"
export * from "./MultipleSelection.vue?vue&type=script&lang=ts"
script.render = render

export default script